( function( app ) {
  const COMPONENT = {
    className: 'bag',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      $( '.bag_archive-banner' ).addClass( 'theme-bg-dark' );
      $( '.ll_bag-template-default, .post-type-archive-ll_bag' ).addClass( 'theme-bg-light' );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'bag', COMPONENT );
} )( app );
